import { useScheduleManage } from '#providers/SchedulesManage';
import { getDayOfWeek } from '#utils/getDayOfWeek';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useRepetitionText() {
  const [value, setValue] = useState<string>('');
  const { selectedLecture } = useScheduleManage();

  const [searchParams] = useSearchParams();
  const lectureScheduleId = decodeURIComponent(
    searchParams.get('lecture-schedule-id') ?? ''
  );

  const isModify = !!lectureScheduleId;

  useEffect(() => {
    if (isModify) {
      setValue('변경');
      return;
    }

    if (!selectedLecture.repetition) {
      setValue('없음');
      return;
    }

    if (selectedLecture.repetition.type === 'WEEKLY') {
      const dayOfWeek = getDayOfWeek(selectedLecture.repetition.daysOfWeek);
      setValue(dayOfWeek === '' ? '없음' : `매주 ${dayOfWeek}요일 반복`);
      return;
    }

    setValue('매일 반복');
  }, []);

  return value;
}
